import { jsx as e } from "react/jsx-runtime";
import { $ as r, M as l } from "../../../ModalDialog-DO3g01h6.js";
const n = ({ ...a }) => a.isOpen ? /* @__PURE__ */ e(r, { children: /* @__PURE__ */ e(l, { ...a, children: a.children }) }) : null;
export {
  n as Modal
};
